export function signedIn() {
  return !!document.querySelector('[data-authenticated]')
}
